import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import { API } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'

class MemberDetailDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'MemberDetailDialog')
        }
    }

    state = {
        input: {
            pf_account: '',
            pf_id: '',
            pf_sub_pf_id: '',
            name: '',
            currency: '',
            money_free: 0,
            money_lock: 0,
            gender: '',
            avatar: 0,
            role_code_id: '',
            created_at: '',
            updated_at: '',
            last_login_at: '',
            last_login_ip: ''
        },
        dialogOpen: false,
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {
        this.setState({ input: {} })
    }

    OpenDialog(inputs) {
        this.reset()
        this.queryContent(inputs)
        this.setState({ dialogOpen: true })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    queryContent(inputs) {
        utils.apiRequest(
            'get',
            API.PLAYER,
            {
                pf_account: inputs.pf_account,
            },
            (data) => {
                data.pf_sub_pf_id = this.props.dataService.pfSubPfMap[data.pf_sub_pf_id].name
                data.pf_id = this.t(`Platform.${data.pf_id}`)
                this.setState({
                    input: {
                        pf_account: data.pf_account,
                        pf_id: data.pf_id,
                        pf_sub_pf_id: data.pf_sub_pf_id,
                        name: data.name,
                        currency: data.currency,
                        money_free: data.money_free * utils.getCurrencyRate(data.currency),
                        money_lock: data.money_lock * utils.getCurrencyRate(data.currency),
                        gender: data.gender,
                        avatar: data.avatar,
                        role_code_id: data.role_code_id,
                        created_at: data.created_at,
                        updated_at: data.updated_at,
                        last_login_at: data.last_login_at,
                        last_login_ip: data.last_login_ip
                    },
                })
            },
            (_err) => {},
            true
        )
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} scroll="paper">
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    {Object.keys(this.state.input).length && <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('pfAccount')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.pf_account}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('pfId')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.pf_id || ''}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('pfSubPfId')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.pf_sub_pf_id || ''}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('name')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.name}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('currency')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.currency && this.t('Currency.' + this.state.input.currency)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('moneyFree')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={utils.currencyFormatter(this.state.input.money_free)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('moneyLock')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={utils.currencyFormatter(this.state.input.money_lock)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('gender')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.gender && this.t(this.state.input.gender)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('avatar')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.avatar}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('roleCodeId')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.role_code_id}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('createdAt')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={utils.unixToDateTime(this.state.input.created_at)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('updatedAt')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={utils.unixToDateTime(this.state.input.updated_at)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('lastLoginAt')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={utils.unixToDateTime(this.state.input.last_login_at)}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('lastLoginIp')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.last_login_ip}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                    </Grid>}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.setState({ dialogOpen: false })} color="primary">
                        {this.t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

MemberDetailDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
}

const styles = (_theme) => ({})

export default hoc(styles)(MemberDetailDialog)
